// extracted by mini-css-extract-plugin
export var btnCopy = "style-module--btn-copy--5e4b5";
export var ok = "style-module--ok--6f9b2";
export var result = "style-module--result--09d70";
export var textWrap = "style-module--text-wrap--0e8da";
export var tg = "style-module--tg--83ea2";
export var vk = "style-module--vk--992c4";